import { render, staticRenderFns } from "./specialtydialog.vue?vue&type=template&id=94f8047c&scoped=true"
import script from "./specialtydialog.vue?vue&type=script&lang=js"
export * from "./specialtydialog.vue?vue&type=script&lang=js"
import style0 from "./specialtydialog.vue?vue&type=style&index=0&id=94f8047c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f8047c",
  null
  
)

export default component.exports